import { render, staticRenderFns } from "./CarsIntroduction-menu.vue?vue&type=template&id=b1adf200&scoped=true&"
import script from "./CarsIntroduction-menu.vue?vue&type=script&lang=js&"
export * from "./CarsIntroduction-menu.vue?vue&type=script&lang=js&"
import style0 from "./CarsIntroduction-menu.vue?vue&type=style&index=0&id=b1adf200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1adf200",
  null
  
)

export default component.exports